"use client";

import { useSidebar } from "@/context/sidebar-context";
import { useUser } from "@/context/user-context";
import classNames from "classnames";
import Icon from "./icon";
import SidebarAccount from "./sidebar/content/sidebar-account";

type SaveForLaterButtonProps = {
  id: string;
  url: string;
  activeLabel?: string;
  inactiveLabel?: string;
  className?: string;
};

const SaveForLaterButton = ({
  id,
  url,
  activeLabel,
  inactiveLabel,
  className,
}: SaveForLaterButtonProps) => {
  const { toggleSaveForLater, savedArticles, isAuthenticated } = useUser();

  const isSavedForLater = (): boolean => {
    if (!id) return false;
    return Boolean(
      id && savedArticles?.some((saved_article_id) => saved_article_id === id),
    );
  };

  const onToggleSaveForLater = () => {
    if (!id) return;
    toggleSaveForLater(id);
  };

  const getLabel = (active: boolean) => {
    const customLabel = active ? activeLabel : inactiveLabel;
    return customLabel;
  };

  const sidebar = useSidebar();

  return (
    <button
      type="button"
      aria-label="Spara att läsa senare"
      onClick={() =>
        isAuthenticated
          ? onToggleSaveForLater()
          : sidebar.open(<SidebarAccount redirectUrl={url} />)
      }
      className={classNames(
        "btn p-0 rounded-sm hover:bg-sand-800 ml-auto bg-sand-700",
        className,
        {
          "": isSavedForLater(),
          "hover:bg-sand-800": !isSavedForLater(),
        },
      )}
    >
      <span className="w-full h-full bg-sand-800 p-2 rounded-sm md:rounded-none md:rounded-l-sm">
        {isSavedForLater() ? (
          <Icon.BookmarkSolid
            className="size-[15px] fill-green-500 text-green-500"
            aria-hidden="true"
          />
        ) : (
          <Icon.Bookmark
            className="size-[15px] fill-black-500 text-black-500"
            aria-hidden="true"
          />
        )}
      </span>
      <span className="px-2 hidden sm:block">
        {getLabel(isSavedForLater())}
      </span>
    </button>
  );
};
export default SaveForLaterButton;
